export default "__VITE_ASSET__daa18e99__"